import { getFolios } from '../math';
import { floatToP2Float } from '../ui';
import { PricingFunction } from './types';

export const priceFolio: PricingFunction = options => {
  const { displayParameters, applicableRate } = options;
  return floatToP2Float(getFolios(displayParameters.words!) * applicableRate);
};
